// extracted by mini-css-extract-plugin
export default {"body":"signUp_body__V07nl","signupInput":"signUp_signupInput__1Nery"};